document.addEventListener("DOMContentLoaded", function () {
  /* === "CHOOSE DIAMOND SETTING" === */
  const diamondBtn = document.querySelector("#openDiamondPopup");
  const variantSwatch = document.querySelector("product-variant-swatch");
  if (diamondBtn && variantSwatch) {
    const fieldsets = variantSwatch.querySelectorAll(
      "fieldset.product-variant-form-input"
    );
    const metalFieldset = fieldsets[1];
    if (metalFieldset) {
      metalFieldset.before(diamondBtn);
      diamondBtn.classList.remove("mt-20");
      diamondBtn.style.marginTop = "0";
      diamondBtn.style.marginBottom = "25px";
    }
  }

  /* === "RING SIZE" TITLE === */
  const ringSizeBtn = document.querySelector("#ring-size-btn");
  if (ringSizeBtn) {
    const ringSizeContainer = ringSizeBtn.closest(
      ".product-single__quantity"
    );
    if (
      ringSizeContainer &&
      !ringSizeContainer.querySelector(".custom-ring-size-title")
    ) {
      const ringTitle = document.createElement("div");
      ringTitle.className =
        "product-single__control-label mb-15 custom-ring-size-title";
      ringTitle.textContent = "Ring Size :";
      ringSizeContainer.insertBefore(
        ringTitle,
        ringSizeContainer.firstChild
      );
    }
  }

  /* === REMOVE SALE % BADGES === */
  document.querySelectorAll(
    ".product-price__badge, .discount-badge, #lockedDiscount"
  ).forEach(function (badge) {
    badge.remove();
  });

  /* === REMOVE "HURRY! OFFER ENDS SOON" === */
  document.querySelectorAll(
    ".offer-blink, .blink-wrapp"
  ).forEach(function (offer) {
    offer.remove();
  });
});